module.exports = "data:image/gif;base64,R0lGODlhCgAKAJECAJWWmI6PkQAAAAAAACH5BAEAAAIALAAAAAAKAAoAAAIaFIR5EKctAjQyScBCQrJuOj2dA3JQtl3GtxYAOw=="